import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const SlideIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12C18 8.68629 20.6863 6 24 6H33C36.3137 6 39 8.68629 39 12V27H48V24C48 20.6863 50.6863 18 54 18H63C66.3137 18 69 20.6863 69 24V57C69 60.3137 66.3137 63 63 63H18C16.3431 63 15 61.6569 15 60C15 58.3432 16.3431 57 18 57V42H9V48C9 49.6569 7.65685 51 6 51C4.34315 51 3 49.6569 3 48V42C3 38.6863 5.68629 36 9 36H18V12ZM39 33H48V57H24V12H33V48C33 49.6569 34.3431 51 36 51C37.6569 51 39 49.6569 39 48V33ZM54 57H63V24H54C54 35 54 57 54 57Z"
      fill="white"
    />
    <path
      d="M6 57C4.34315 57 3 58.3432 3 60C3 61.6569 4.34315 63 6 63C7.65685 63 9 61.6569 9 60C9 58.3432 7.65685 57 6 57Z"
      fill="white"
    />
  </SvgIcon>
);
SlideIcon.displayName = "SlideIcon";
SlideIcon.muiName = "SvgIcon";

export default pure(SlideIcon);
